import { useSyncExternalStore } from 'react';
import { getTargetAttackUiSnapshot, subscribeTargetAttackUi } from '../../state/targetAttackUiStore.ts';
import { TARGET_ATTACK_DOM } from './targetAttackDomIds.ts';
import { useI18n } from 'shared/lib/i18n.tsx';

export function TargetAttackPause() {
  const d = TARGET_ATTACK_DOM;
  const { t } = useI18n();
  const s = useSyncExternalStore(
    subscribeTargetAttackUi,
    getTargetAttackUiSnapshot,
    getTargetAttackUiSnapshot,
  );

  const pauseBody =
    s.pauseSplit && s.pauseP1 !== null && s.pauseP2 !== null
      ? `${s.pauseP1} : ${s.pauseP2}`
      : String(s.pauseScoreSingle);

  return (
    <div
      id={d.pauseRoot}
      className="target-attack-pause"
      hidden={!s.pauseVisible}
      role="dialog"
      aria-modal="true"
      aria-labelledby={d.pauseTitle}
    >
      <div className="target-attack-pause__panel">
        <h2 id={d.pauseTitle} className="target-attack-pause__title">
          {t('game.pause')}
        </h2>
        <div className="target-attack-pause__score">{pauseBody}</div>
      </div>
    </div>
  );
}
